var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13451",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37 37",
    style: {
      enableBackground: "new 0 0 37 37"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFCC00;}\n\t.st2{fill:#00678F;}\n\t.st3{fill:#FF0000;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4491",
    className: "st0",
    width: 37,
    height: 37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    className: "st1",
    d: "M1.9,1.9h33.3v33.3H1.9V1.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    className: "st2",
    d: "M18.5,25c8.7,0,15.7-2.9,15.7-6.5s-7-6.5-15.7-6.5S2.8,14.9,2.8,18.5S9.8,25,18.5,25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    className: "st1",
    d: "M22.5,16.9l0.4-1.6h-5.4l-0.4,1.6h1.8L18,20.4h1.9l0.9-3.5H22.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    className: "st0",
    d: "M17,15.3h-2.7l-1.7,3.8v-3.8H10l-1.6,6.5h1.8l1.1-4.2v4.2h1.4l2-4.2l-1,4.2h1.7L17,15.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    className: "st0",
    d: "M28.6,15.3h-1.7L26,18.7l-0.8-3.4h-1.9l-1.6,6.5h1.7l0.9-3.5l0.9,3.5H27L28.6,15.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    className: "st3",
    d: "M17.9,20.8l-0.2,0.9h1.8l0.2-0.9H17.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtn);
export default __webpack_public_path__ + "static/media/mtn.ec43d048ab68303ec02b574f082ddafb.svg";
export { ForwardRef as ReactComponent };